import React from 'react';
import { BrowserRouter as Router, Switch, Route } from 'react-router-dom';

import { LoginPage } from './pages/LoginPage';
import { MfaPage } from './pages/MfaPage';
import { DashboardPage } from './pages/DashboardPage';
import { CustomerList } from './pages/CustomerList';
import { CustomerType } from './pages/CustomerType';
import { CreateCustomer } from './pages/CreateCustomer';
import { VendorList } from './pages/VendorList';
import { CreateVendor } from './pages/CreateVendor';
import { ConstructionList } from './pages/ConstructionList';
import { EmployeeGroupList } from './pages/EmployeeGroupList';
import { CreateEmployeeGroup } from './pages/CreateEmployeeGroup';
import { EmployeeMasterList } from './pages/EmployeeMasterList';
import { EstimatesList } from './pages/EstimatesList';
import { EstimateMaster } from './pages/EstimateMaster';
import { EditEstimateMaster } from './pages/EditEstimateMaster';
import { CreateConstructionList } from './pages/CreateConstructionList';
import { InvoicePage } from './pages/InvoicePage';
import { ProductPurchaseOrder } from './pages/ProductPurchaseOrder';
import { OutsourcedPurchaseOrder } from './pages/OutsourcedPurchaseOrder';
import { SiteContacts } from './pages/SiteContacts';
import { CreateEmployeeMaster } from './pages/CreateEmployeeMaster';
import { CreateEmployeeHealthStatus } from './pages/CreateEmployeeHealthStatus';
import { CreateEmployeeEmergencyInfo } from './pages/CreateEmployeeEmergencyInfo';
import { CreateEmployeeCredentialsInfo } from './pages/CreateEmployeeCredentialsInfo';
import { EditVendor } from './pages/EditVendor';
import { EditConstruction } from './pages/EditConstruction';
import { EditConstructionDocument } from './pages/EditConstructionDocument';
import { EditConstructionLocation } from './pages/EditConstructionLocation';
import { CreateProductPurchaseOrder } from './pages/CreateProductPurchaseOrder';
import { EditEstimates } from './pages/EditEstimates';
import { EditInvoice } from './pages/EditInvoice';
import { ContractFormat } from './pages/ContractFormat';
import { EditProductPurchase } from './pages/EditProductPurchase';
import { EditOutSources } from './pages/EditOutSources';
import { EditSiteContacts } from './pages/EditSiteContacts';
import { TargetValueSetting } from './pages/TargetValueSetting';
import { PreviewEstimates } from './pages/PreviewEstimates';
import { PreviewInvoices } from './pages/PreviewInvoices';
import { ResetPassword } from './pages/ResetPassword';
import { ResetPasswordPage } from './pages/ResetPasswordPage';
import { ConfirmMailPage } from './pages/ConfirmMailPage';
import { PreviewProductPurchase } from './pages/PreviewProductPurchase';
import { PreviewOutsource } from './pages/PreviewOutsource';
import { PreviewSiteContact } from './pages/PreviewSiteContact';
import { NotFoundPage } from './pages/NotFoundPage';
import { CompanyInformation } from './pages/CompanyInformation';
import { PdfDownloadPage } from './pages/PdfDownloadPage';
import { FileListPage } from './pages/FileListPage';
import { PictureListPage } from './pages/PictureListPage';
import { FileTypePage } from './pages/FileTypePage';
import { FileLogPage } from './pages/FileLogPage';
import { PictureLogPage } from './pages/PictureLogPage';
import { ShareFileListPage } from './pages/ShareFileListPage';
import { SharePictureListPage } from './pages/SharePictureListPage';
import { GuestManagePage } from './pages/GuestManagePage';
import { DocumentTransmissionPage } from './pages/DocumentTransmissionPage';
import { AuthContextProvider } from './AuthContextProvider';
import { AuthGuard } from './AuthGuard';
import { SnackbarProvider } from 'notistack';
import { SiteManageAuthWrapperProcessPage } from './pages/SiteManageAuthWrapperProcessPage';
import { SiteManageAuthWrapperTaskPage } from './pages/SiteManageAuthWrapperTaskPage';
import { SiteManageAuthWrapperDailyReportPage } from './pages/SiteManageAuthWrapperDailyReportPage';
import { SiteManageAuthWrapperCalendarPage } from './pages/SiteManageAuthWrapperCalendarPage';
import { DailyReportForWorkersPage } from './pages/DailyReportForWorkersPage';
import { DocumentExternalSharePage } from './pages/DocumentExternalSharePage';
import { PreviewDownloadEstimate } from './pages/PreviewDownloadEstimate';
import { PreviewDownloadInvoice } from './pages/PreviewDownloadInvoice';
import { PreviewDownloadProductPurchase } from './pages/PreviewDownloadProductPurchase';
import { PreviewDownloadOutsource } from './pages/PreviewDownloadOutsource';
import { PreviewDownloadSitecontact } from './pages/PreviewDownloadSitecontact';
import { CreateLedger } from './pages/CreateLedger';
import { LedgerListPage } from './pages/LedgerListPage';
import { EditLedger } from './pages/EditLedger';
import { PartnerCategoryPage } from './pages/PartnerCategoryPage';
import { ChangePassword } from './pages/ChangePassword';
import { AccessibleMenu } from './AccessibleMenu';
import { UnitMasterPage } from './pages/UnitMasterPage';
import { ConstructTypePage } from './pages/ConstructType';
import { WorkingBudgetPage } from './pages/WorkingBudgetPage';
import { WorkingBudgetList } from './pages/WorkingBudgetList';
import { AttendanceManagePage } from './pages/AttendanceManagePage';
import { PreviewReceipts } from './pages/PreviewReceipts';
import { AttendanceManagementDashboard } from './pages/AttendanceManagementDashboard';

const App: React.FC = () => {
  // 画面更新モーダルオープン
  // const [screenUpdateModalOpen, setScreenUpdateModalOpen] = useState(false);

  // useEffect(() => {
  //   console.log(process.env.REACT_APP_REVISION_ID);
  //   const revisionId = process.env.REACT_APP_REVISION_ID

  //   // setInterval関数で定期実行する
  //   setInterval(() => {
  //     axios.get('https://eatas-test.s3.ap-northeast-1.amazonaws.com/revision.json').then(res => {
  //       console.log(res);
  //       if (revisionId !== res.data.revisionId) {
  //         setScreenUpdateModalOpen(true)
  //       }
  //     }).catch((err) => {
  //       console.log(err);
  //     })
  //     // 1分に1回確認
  //   }, 10000)
  // }, [])

  return (
    <AuthContextProvider>
      <SnackbarProvider
        maxSnack={4}
        autoHideDuration={4000}
        anchorOrigin={{
          vertical: 'bottom',
          horizontal: 'center'
        }}
      >
        <Router>
          <Switch>
            <Route path='/' exact component={LoginPage} />
            {/* メールの二段階認証画面 */}
            <Route path='/mfa' exact component={MfaPage} />
            {/* パスワードリセット メールアドレス入力画面 */}
            <Route path='/reset' exact component={ResetPassword} />
            {/* パスワードリセット 新パスワード入力画面 */}
            <Route
              path='/reset/password/:id'
              exact
              component={ResetPasswordPage}
            />
            {/* 新メールアドレス 確認画面 */}
            <Route
              path='/confirm/email/:id'
              exact
              component={ConfirmMailPage}
            />

            <AccessibleMenu>
              {/* ダッシュボード画面 */}
              <Route path='/dashboard' exact component={DashboardPage} />
              {/* 目標設定画面 */}
              <Route
                path='/sales/setting'
                exact
                component={TargetValueSetting}
              />
              {/* 顧客一覧画面 */}
              <Route path='/customers' exact component={CustomerList} />
              {/* 顧客種別一覧画面 */}
              <Route path='/customertypes' exact component={CustomerType} />
              {/* 顧客新規作成画面 */}
              <Route
                path='/customers/create'
                exact
                component={CreateCustomer}
              />
              {/* 顧客編集画面 */}
              <Route
                path='/customers/:id/edit'
                exact
                component={CreateCustomer}
              />
              {/* 業者一覧画面 */}
              <Route path='/vendors' exact component={VendorList} />
              {/* 業者新規作成画面 */}
              <Route path='/vendors/create' exact component={CreateVendor} />
              {/* 業者編集画面*/}
              <Route path='/vendors/:id/edit' exact component={EditVendor} />
              {/* 業種マスタ画面*/}
              <Route
                path='/partner-categories'
                exact
                component={PartnerCategoryPage}
              />
              {/* 単位マスタ画面*/}
              <Route path='/unit_master' exact component={UnitMasterPage} />
              {/* 案件種別マスタ画面*/}
              <Route
                path='/construct-types'
                exact
                component={ConstructTypePage}
              />
              {/* 工事一覧画面 */}
              <Route path='/constructions' exact component={ConstructionList} />
              {/* 工事新規作成画面 */}
              <Route
                path='/constructions/create'
                exact
                component={CreateConstructionList}
              />
              {/* 工事編集 工事情報画面 */}
              <Route
                path='/constructions/:id/edit'
                exact
                component={EditConstruction}
              />
              {/* 工事編集 書類情報画面 */}
              <Route
                path='/constructions_document/:id/edit'
                exact
                component={EditConstructionDocument}
              />
              {/* 工事編集 現場情報画面 */}
              <Route
                path='/constructions_location/:id/edit'
                exact
                component={EditConstructionLocation}
              />

              {/* 社員グループ一覧画面 */}
              <Route
                path='/employee-groups'
                exact
                component={EmployeeGroupList}
              />
              {/* 社員グループ新規作成画面 */}
              <Route
                path='/employee-groups/create'
                exact
                component={CreateEmployeeGroup}
              />
              {/* 社員グループ編集画面 */}
              <Route
                path='/employee-groups/:id/edit'
                exact
                component={CreateEmployeeGroup}
              />
              {/* 社員一覧画面 */}
              <Route
                path='/employee-masters'
                exact
                component={EmployeeMasterList}
              />
              {/* 社員新規作成画面 */}
              <Route
                path='/employee-masters/create'
                exact
                component={CreateEmployeeMaster}
              />
              {/* 社員編集画面 */}
              <Route
                path='/employee-masters/:id/edit'
                exact
                component={CreateEmployeeMaster}
              />
              {/* 健康状態新規作成画面 */}
              <Route
                path='/employee-health-info/create'
                exact
                component={CreateEmployeeHealthStatus}
              />
              {/* 健康状態編集画面 */}
              <Route
                path='/employee-health-info/:id/edit'
                exact
                component={CreateEmployeeHealthStatus}
              />
              {/* 緊急連絡先情報新規作成画面 */}
              <Route
                path='/employee-emergency-info/create'
                exact
                component={CreateEmployeeEmergencyInfo}
              />
              {/* 緊急連絡先情報編集画面 */}
              <Route
                path='/employee-emergency-info/:id/edit'
                exact
                component={CreateEmployeeEmergencyInfo}
              />
              {/* 資格情報新規作成画面 */}
              <Route
                path='/employee-credentials-info/create'
                exact
                component={CreateEmployeeCredentialsInfo}
              />
              {/* 資格情報編集画面 */}
              <Route
                path='/employee-credentials-info/:id/edit'
                exact
                component={CreateEmployeeCredentialsInfo}
              />
              {/* 作成済書類見積書一覧画面 */}
              <Route path='/estimates' exact component={EstimatesList} />
              {/* 見積書マスタ一覧画面 */}
              <Route path='/estimate-master' exact component={EstimateMaster} />
              {/* 見積書マスタ新規作成画面 */}
              <Route
                path='/estimate-master/create'
                exact
                component={EditEstimateMaster}
              />
              {/* 見積書マスタ編集画面 */}
              <Route
                path='/estimate-master/:id/edit'
                exact
                component={EditEstimateMaster}
              />
              {/* 作成済書類 請求書一覧画面 */}
              <Route path='/invoices' exact component={InvoicePage} />
              {/* 作成済書類 商品発注書一覧画面 */}
              <Route
                path='/merchandise-orders'
                exact
                component={ProductPurchaseOrder}
              />
              {/* 作成済書類 外注発注書一覧画面 */}
              <Route
                path='/outsource-orders'
                exact
                component={OutsourcedPurchaseOrder}
              />
              {/* 作成済書類 現場連絡表一覧画面 */}
              <Route path='/site-contacts' exact component={SiteContacts} />
              {/* 作成済書類 実行予算一覧画面 */}
              <Route
                path='/working-budget'
                exact
                component={WorkingBudgetPage}
              />
              {/* 見積書 新規作成画面 */}
              <Route path='/estimates/create' exact component={EditEstimates} />
              {/* 請求書 新規作成画面 */}
              <Route path='/invoices/create' exact component={EditInvoice} />
              {/* 商品発注書 新規作成画面 */}
              <Route
                path='/merchandise-orders/create'
                exact
                component={CreateProductPurchaseOrder}
              />
              {/* 外注発注書新規作成画面 */}
              <Route
                path='/outsource-orders/create'
                exact
                component={EditOutSources}
              />
              {/* 現場連絡表新規作成画面 */}
              <Route
                path='/site-contacts/create'
                exact
                component={EditSiteContacts}
              />
              {/* 見積書 編集画面 */}
              <Route
                path='/estimates/:id/edit'
                exact
                component={EditEstimates}
              />
              {/* 請求書 編集画面 */}
              <Route path='/invoices/:id/edit' exact component={EditInvoice} />
              {/* 商品発注書 編集画面 */}
              <Route
                path='/merchandise-orders/:id/edit'
                exact
                component={EditProductPurchase}
              />
              {/* 外注発注書 編集画面 */}
              <Route
                path='/outsource-orders/:id/edit'
                exact
                component={EditOutSources}
              />
              {/* 現場連絡表 編集画面 */}
              <Route
                path='/site-contacts/:id/edit'
                exact
                component={EditSiteContacts}
              />
              {/* 見積書 pdfプレビュー画面 */}
              <Route
                path='/estimates/:id/preview'
                exact
                component={PreviewEstimates}
              />
              {/* 請求書 pdfプレビュー画面 */}
              <Route
                path='/invoices/:id/preview'
                exact
                component={PreviewInvoices}
              />
              {/* 商品発注書 pdfプレビュー画面 */}
              <Route
                path='/merchandise-orders/:id/preview'
                exact
                component={PreviewProductPurchase}
              />
              {/* 領収書 pdfプレビュー画面 */}
              <Route
                path='/receipts/:id/preview'
                exact
                component={PreviewReceipts}
              />
              {/* 外注発注書 pdfプレビュー画面 */}
              <Route
                path='/outsource-orders/:id/preview'
                exact
                component={PreviewOutsource}
              />
              {/* 現場連絡表 pdfプレビュー画面 */}
              <Route
                path='/site-contacts/:id/preview'
                exact
                component={PreviewSiteContact}
              />
              {/* 自社情報 画面 */}
              <Route
                path='/company-information'
                exact
                component={CompanyInformation}
              />
              {/* PDFダウンロード画面 */}
              <Route path='/pdf' exact component={PdfDownloadPage} />

              {/* 実行予算 */}
              <Route
                path='/working_budget'
                exact
                component={WorkingBudgetPage}
              />
              <Route
                path='/working-budgets'
                exact
                component={WorkingBudgetList}
              />

              {/* 外部共有先のページ */}
              <Route path='/sharefile' exact component={ShareFileListPage} />
              <Route
                path='/sharepicture'
                exact
                component={SharePictureListPage}
              />

              {/* 書類ダウンロード */}
              <Route
                path='/document/external/share'
                exact
                component={DocumentExternalSharePage}
              />
              <Route
                path='/download/estimate/:id/preview'
                exact
                component={PreviewDownloadEstimate}
              />
              <Route
                path='/download/invoice/:id/preview'
                exact
                component={PreviewDownloadInvoice}
              />
              <Route
                path='/download/product/purchase/:id/preview'
                exact
                component={PreviewDownloadProductPurchase}
              />
              <Route
                path='/download/outsource/:id/preview'
                exact
                component={PreviewDownloadOutsource}
              />
              <Route
                path='/download/sitecontact/:id/preview'
                exact
                component={PreviewDownloadSitecontact}
              />

              {/* 日報作成(職人用) */}
              <Route
                path='/nippo'
                exact
                component={DailyReportForWorkersPage}
              />

              {/* 工程表 */}
              <Route
                path='/processes'
                exact
                component={SiteManageAuthWrapperProcessPage}
              />
              {/* タスク管理 */}
              <Route
                path='/constructions/:constructId/tasks'
                exact
                component={SiteManageAuthWrapperTaskPage}
              />
              {/* 日報 */}
              <Route
                path='/daily-reports'
                exact
                component={SiteManageAuthWrapperDailyReportPage}
              />
              {/* カレンダー */}
              <Route
                path='/calendar'
                exact
                component={SiteManageAuthWrapperCalendarPage}
              />

              {/* 出面管理 */}
              <Route
                path='/attendance'
                exact
                component={AttendanceManagementDashboard}
              />
              {/*<Route path='/attendance-dashboard' exact component={AttendanceManagementDashboard} />*/}

              {/* パスワード変更画面 */}
              <Route path='/change/password' exact component={ChangePassword} />

              {/* TODO：影響がなければ<AuthGuard>を削除 */}
              {/* <AuthGuard> */}
              {/* クラウドストレージ写真画面*/}
              <Route path='/pictures' exact component={PictureListPage} />
              {/* クラウドストレージ書類画面*/}
              <Route path='/files' exact component={FileListPage} />
              {/* クラウドストレージ資料一覧画面*/}
              <Route path='/filetypes' exact component={FileTypePage} />
              {/* クラウドストレージ共有先管理画面*/}
              <Route path='/guest-manage' exact component={GuestManagePage} />
              {/* 書類の送信履歴のパス*/}
              <Route
                path='/document-transmission'
                exact
                component={DocumentTransmissionPage}
              />

              {/* 写真台帳作成画面のパス*/}
              <Route path='/create-ledger' exact component={CreateLedger} />
              {/* 写真台帳編集画面のパス*/}
              <Route path='/edit-ledger' exact component={EditLedger} />
              {/* 写真台帳作成画面のパス*/}
              <Route path='/ledger-list' exact component={LedgerListPage} />

              {/* クラウドストレージ資料操作履歴画面*/}
              <Route path='/filelog' exact component={FileLogPage} />
              {/* クラウドストレージ写真操作履歴画面*/}
              <Route path='/picturelog' exact component={PictureLogPage} />
              {/* </AuthGuard> */}
            </AccessibleMenu>

            <Route exact component={NotFoundPage} />
          </Switch>
        </Router>

        {/* 画面更新モーダル */}
        {/* <ScreenUpdateModal
        modalOpen={screenUpdateModalOpen}
        setModalOpen={setScreenUpdateModalOpen}
      /> */}
      </SnackbarProvider>
    </AuthContextProvider>
  );
};

export default App;
